import { FC, useState } from 'react';

import { Button, Flex, Layout, SiderProps } from 'antd';
import cn from 'classnames';

import AngleDownIcon from 'assets/images/icons/angle-down.svg?react';
import logoAdv from 'assets/images/logo/logo-adv.svg';
import logoAdvShort from 'assets/images/logo/logo-adv-short.svg';
import logoPub from 'assets/images/logo/logo-pub.svg';
import logoPubShort from 'assets/images/logo/logo-pub-short.svg';
import { Navigation } from 'features/Navigation';
import { useDisableBodyScroll, useMedia } from 'shared/hooks';
import { Logo } from 'shared/ui';

import styles from './Sidebar.module.scss';

interface ISidebarProps extends SiderProps {
	isPublisher?: boolean;
}

export const Sidebar: FC<ISidebarProps> = ({ isPublisher, ...props }: ISidebarProps) => {
	const isDesktop = useMedia('desktop');
	const [collapsed, setCollapsed] = useState(false);
	useDisableBodyScroll(!isDesktop && collapsed);
	const logoShort = isPublisher ? logoPubShort : logoAdvShort;
	const logo = isPublisher ? logoPub : logoAdv;
	const currentLogo = collapsed ? logoShort : logo;
	return (
		<Layout.Sider
			theme="light"
			className={styles.sidebar}
			width="270"
			trigger={null}
			collapsible
			collapsed={collapsed}
			{...props}>
			<Flex vertical gap={12}>
				{collapsed && <Logo image={currentLogo} width={42} height={20} style={{ padding: 12 }} />}
				{!collapsed && <Logo image={currentLogo} width={118} height={63} style={{ padding: 12 }} />}
				<Navigation isPublisher={isPublisher} />
			</Flex>
			<Button
				onClick={() => {
					setCollapsed(!collapsed);
				}}
				shape="circle"
				className={styles.collapser}
				size="small">
				<AngleDownIcon className={cn(styles.icon, { [styles.iconCollapsed]: collapsed })} />
			</Button>
		</Layout.Sider>
	);
};
